import React from 'react';
import './timesheet-decision.scss';

export default function TimesheetApprovalDeclaration({ declaration }) {
  if (!declaration) return null;
  return (
    <section className="timesheet-decision__declaration" aria-label="Declaration">
      <h5>Declaration</h5>
      <p>By approving or rejecting a timesheet you are agreeing to the following:</p>
      <p className="timesheet-decision__declaration-text">{declaration}</p>
    </section>
  );
}
